<template>
  <div class="form-item">
    <div class="form-item-content">
      <slot></slot>
    </div>
    <div class="form-item-tip">{{validateMessage}}</div>
  </div>
</template>
<script>
export default {
    name: 'form-item',
    props: {
        error: String
    },
    data() {
        return {
            validateStatus: '',
            validateMessage: ''
        };
    },
    methods: {
        clearValidate() {
            this.validateStatus = '';
            this.validateMessage = '';
        },
        setMsg(msg) {
            this.validateMessage = msg;
            this.validateState = msg ? 'error' : '';
        }
    }
};
</script>




// WEBPACK FOOTER //
// FormItem.vue?23ef9b39